import React from "react";
import styled from "styled-components";

const BoardCategoryFilter = ({
  activeCategory,
  categories,
  onSelect,
  title,
}) => {
  if (categories.length === 0) return null;

  return (
    <StyledBoardCategoryFilter aria-label={`${title} 카테고리`}>
      <span className="board-category-label">카테고리</span>
      <div className="board-category-buttons">
        {["", ...categories].map((category) => {
          const isActive = activeCategory === category;

          return (
            <button
              type="button"
              className={`board-category-button${isActive ? " is-active" : ""}`}
              aria-pressed={isActive}
              onClick={() => onSelect(category)}
              key={category || "all"}
            >
              {category || "전체"}
            </button>
          );
        })}
      </div>
    </StyledBoardCategoryFilter>
  );
};

const StyledBoardCategoryFilter = styled.nav`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid var(--crypto-border-soft);
  border-radius: 12px;
  background:
    linear-gradient(90deg, rgba(89, 244, 119, 0.08), transparent 38%),
    var(--crypto-surface-2);

  .board-category-label {
    flex: 0 0 auto;
    color: #ffffff;
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
  }

  .board-category-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    overflow-x: auto;
    padding: 1px 2px 3px;
    scrollbar-width: none;
  }

  .board-category-buttons::-webkit-scrollbar {
    display: none;
  }

  .board-category-button {
    flex: 0 0 auto;
    height: 34px;
    border: 1px solid rgba(177, 205, 224, 0.13);
    border-radius: 999px;
    padding: 0 14px;
    color: #b8c7d3;
    background: rgba(8, 24, 31, 0.72);
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
    cursor: pointer;
    transition:
      border-color 160ms ease,
      background 160ms ease,
      color 160ms ease,
      box-shadow 160ms ease;
  }

  .board-category-button:hover {
    border-color: rgba(89, 244, 119, 0.36);
    color: #ffffff;
  }

  .board-category-button.is-active {
    border-color: rgba(89, 244, 119, 0.52);
    color: #07150d;
    background: var(--crypto-green);
    box-shadow: 0 8px 18px rgba(38, 210, 91, 0.18);
  }

  @media (max-width: 720px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 9px;
    padding: 11px 12px;

    .board-category-buttons {
      width: 100%;
    }

    .board-category-button {
      height: 32px;
      padding: 0 12px;
    }
  }
`;

export default BoardCategoryFilter;
